import { useCallback, useMemo } from 'react';

import { useCollection } from '@frontend/api';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { useAppSelector } from 'store/hooks';
import { useFeatureFlagValue } from 'store/session/hooks';
import { getUserGroupCollectionId } from 'store/session/selectors';

export const useUserGroupLookup = () => {
  const isMultisiteEnabled = useFeatureFlagValue(
    featureFlagKeys.isMultisiteFunctionalityAvailable,
  );
  const userGroupCollectionId = useAppSelector(getUserGroupCollectionId);

  const isEnabled = useMemo(() => {
    return isMultisiteEnabled && !!userGroupCollectionId;
  }, [isMultisiteEnabled, userGroupCollectionId]);

  const { data: collection } = useCollection(
    { collectionId: userGroupCollectionId },
    { queryOptions: { enabled: isEnabled } },
  );

  const userGroupsById = useMemo(() => {
    if (!isEnabled) {
      return {};
    }
    const userGroups = collection?.userGroups ?? [];
    return Object.fromEntries(userGroups.map((group) => [group.id, group]));
  }, [collection, isEnabled]);

  const getUserGroupById = useCallback(
    (groupId: number) => {
      return userGroupsById[groupId];
    },
    [userGroupsById],
  );

  return { userGroupsById, getUserGroupById };
};
